import React from 'react'
import PropTypes from 'prop-types'

import { makeStyles, List } from '@material-ui/core'

import TreeViewItemWrapper from './treeViewItemWrapper'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  }
}))

const ZariTreeView = ({ items, onItemClick }) => {
  const classes = useStyles()
  const [selectedId, setSelectedId] = React.useState('')

  const tree = React.useMemo(() => {
    const menu = items
    const root = []
    const map = {}

    menu.forEach(node => {
      // No parentId means top level
      if (!node._parentId) return root.push(node)

      // Insert node as child of parent in flat array
      let parentIndex = map[node._parentId]
      if (typeof parentIndex !== 'number') {
        parentIndex = menu.findIndex(el => el._id === node._parentId)
        map[node.parentId] = parentIndex
      }

      if (!menu[parentIndex].childs) {
        return (menu[parentIndex].childs = [node])
      }

      menu[parentIndex].childs.push(node)
    })

    return root
  }, [items])

  return (
    <div className='zari-treeview'>
      <List dense component='nav' className={classes.root}>
        {tree.map(x => (
          <TreeViewItemWrapper key={x._id} item={x} selectedId={selectedId} setSelectedId={setSelectedId} clickItemHandler={onItemClick} />
        ))}
      </List>
    </div>
  )
}

ZariTreeView.propTypes = {
  items: PropTypes.array,
  onItemClick: PropTypes.func
}

export default React.memo(ZariTreeView)
